<template>
  <div>
    <div class="page-wrapper">
      <div class="page-content-wrapper">
        <div class="shadow-btm">
          <div class="row col-lg-6 col-sm-6 my-auto">
            <h4 class="mb-0 lg-bld">Success Stories</h4>
          </div>
        </div>
        <div
          class="page-content"
          v-show="accessObject?.is_view == 1 || !isShowAccessDeniedMessage">
          <div class="card-body py-0 px-0">
            <ul class="nav nav-pills mb-3 pb-3">
              <li class="nav-item">
                <a
                  class="nav-link"
                  data-toggle="tab"
                  :class="{ active: currentTab == 'PENDING' }"
                  v-on:click="changeTab('PENDING')"
                  style="cursor: pointer">
                  <span>Pending Requests</span></a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  data-toggle="tab"
                  :class="{ active: currentTab == 'ACCEPTED' }"
                  v-on:click="changeTab('ACCEPTED')"
                  style="cursor: pointer">
                  <span>Success Stories</span></a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  data-toggle="tab"
                  :class="{ active: currentTab == 'REJECTED' }"
                  v-on:click="changeTab('REJECTED')"
                  style="cursor: pointer">
                  <span>Rejected Requests</span></a
                >
              </li>
            </ul>
            <div class="row">
              <div class="col-lg-6 col-sm-6 form-group row">
                <div class="has-search ml-3">
                  <!-- <span class="bx bx-search form-control-feedback"></span> -->
                  <i
                    class="fa fa-search"
                    style="position: absolute; margin: 10px"
                    aria-hidden="true"></i>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search "
                    v-model="searchObj.keyword"
                    v-on:keyup.enter="getList(0)" />
                </div>
                <a
                  class="fill-btn btn-style cursor-pointer ml-3"
                  v-on:click="getList(0)"
                  >Search</a
                >
                <a
                  class="fill-btn btn-style cursor-pointer"
                  v-on:click="resetFilter()"
                  v-show="searchObj.keyword"
                  >Reset</a
                >
              </div>
              <div
                style="cursor: pointer"
                v-show="currentTab == 'ACCEPTED'"
                class="col-lg-6 col-sm-6 mb-1 txt-right form-group">
                <a
                  v-show="accessObject?.is_add == 1"
                  class="fill-btn btn-style cursor-pointer ml-3"
                  v-on:click="$router.push('/add-succcess-stories')"
                  >+ Add</a
                >
              </div>
            </div>
            <div class="card border mb-0 radius-15">
              <div v-show="currentTab == 'PENDING'">
                <div class="card border mb-0 radius-15">
                  <div class="card-body p-0 pb-4">
                    <div class="table-responsive">
                      <div class="dataTables_wrapper dt-bootstrap4">
                        <table
                          class="table table-striped table-bordered dataTable"
                          style="width: 100%"
                          role="grid"
                          aria-describedby="example_info">
                          <thead>
                            <tr role="row">
                              <th>Sr. No.</th>
                              <th
                                class="sorting"
                                id="id-custom_request_id"
                                v-on:click="
                                  sorting(
                                    'custom_request_id',
                                    'id-custom_request_id'
                                  )
                                ">
                                <div style="width: 105px">Request ID</div>
                              </th>
                              <th
                                class="sorting"
                                id="id-action_datetime"
                                v-on:click="
                                  sorting(
                                    'action_datetime',
                                    'id-action_datetime'
                                  )
                                ">
                                <div style="width: 145px">Requested Date</div>
                              </th>
                              <th>Groom ID First Name Last Name</th>
                              <th>
                                <div style="width: 250px">
                                  Bride ID First Name Last Name
                                </div>
                              </th>
                              <th v-show="accessObject?.is_view == 1">
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody v-show="!requestedProductLoader">
                            <tr v-for="(data, index) in list" :key="index">
                              <td style="text-align: left">
                                {{
                                  ($refs.listPagination.currentPage - 1) * 10 +
                                  index +
                                  1
                                }}
                              </td>
                              <td style="text-align: left">
                                {{
                                  data.custom_request_id
                                    ? data.custom_request_id
                                    : "-"
                                }}
                              </td>
                              <td style="text-align: left">
                                {{
                                  $helperService.getFormatedDate(
                                    data.action_datetime
                                      ? data.action_datetime
                                      : "-"
                                  )
                                }}
                              </td>
                              <td style="text-align: left">
                                {{
                                  data.groom_registration_no
                                    ? data.groom_registration_no
                                    : "-"
                                }}
                                {{
                                  data.groom_first_name
                                    ? data.groom_first_name
                                    : "-"
                                }}
                                {{
                                  data.groom_last_name
                                    ? data.groom_last_name
                                    : "-"
                                }}
                              </td>
                              <td style="text-align: left">
                                {{
                                  data.bride_registration_no
                                    ? data.bride_registration_no
                                    : "-"
                                }}
                                {{
                                  data.bride_first_name
                                    ? data.bride_first_name
                                    : "-"
                                }}
                                {{
                                  data.bride_last_name
                                    ? data.bride_last_name
                                    : "-"
                                }}
                              </td>

                              <td>
                                <router-link
                                  :to="'/view-succcess-stories/' + data.uuid">
                                  <a
                                    v-show="accessObject?.is_view == 1"
                                    class="fill-btn btn-style cursor-pointer"
                                    >View</a
                                  >&nbsp;
                                </router-link>
                                <a
                                  class="fill-btn btn-style cursor-pointer"
                                  v-on:click="showAcceptPopup(data)"
                                  >Accept</a
                                >&nbsp;
                                <a
                                  class="fill-btn btn-style cursor-pointer"
                                  v-on:click="showRejectPopup(data)"
                                  >Reject</a
                                >&nbsp;
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-show="currentTab == 'ACCEPTED'">
                <div class="mb-0 radius-15">
                  <div class="card-body p-0 pb-4">
                    <div class="table-responsive">
                      <div class="dataTables_wrapper dt-bootstrap4">
                        <table
                          class="table table-striped table-bordered dataTable"
                          style="width: 100%"
                          role="grid"
                          aria-describedby="example_info">
                          <thead>
                            <tr role="row">
                              <th>Sr. No.</th>
                              <th
                                class="sorting"
                                id="id-custom_request_id"
                                v-on:click="
                                  sorting(
                                    'custom_request_id',
                                    'id-custom_request_id'
                                  )
                                ">
                                <div style="width: 105px">Request ID</div>
                              </th>
                              <th
                                class="sorting"
                                id="id-action_datetime"
                                v-on:click="
                                  sorting(
                                    'action_datetime',
                                    'id-action_datetime'
                                  )
                                ">
                                <div style="width: 145px">Requested Date</div>
                              </th>
                              <th>Groom ID First Name Last Name</th>
                              <th>
                                <div style="width: 250px">
                                  Bride ID First Name Last Name
                                </div>
                              </th>
                              <th
                                v-show="
                                  accessObject?.is_delete == 1 ||
                                  accessObject?.is_view == 1
                                ">
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody v-show="!requestedProductLoader">
                            <tr v-for="(data, index) in list" :key="index">
                              <td style="text-align: left">
                                {{
                                  ($refs.listPagination.currentPage - 1) * 10 +
                                  index +
                                  1
                                }}
                              </td>
                              <td style="text-align: left">
                                {{
                                  data.custom_request_id
                                    ? data.custom_request_id
                                    : "-"
                                }}
                              </td>
                              <td style="text-align: left">
                                {{
                                  $helperService.getFormatedDate(
                                    data.action_datetime
                                      ? data.action_datetime
                                      : "-"
                                  )
                                }}
                              </td>
                              <td style="text-align: left">
                                {{
                                  data.groom_registration_no
                                    ? data.groom_registration_no
                                    : "-"
                                }}
                                {{
                                  data.groom_first_name
                                    ? data.groom_first_name
                                    : "-"
                                }}
                                {{
                                  data.groom_last_name
                                    ? data.groom_last_name
                                    : "-"
                                }}
                              </td>

                              <td style="text-align: left">
                                {{
                                  data.bride_registration_no
                                    ? data.bride_registration_no
                                    : "-"
                                }}
                                {{
                                  data.bride_first_name
                                    ? data.bride_first_name
                                    : "-"
                                }}
                                {{
                                  data.bride_last_name
                                    ? data.bride_last_name
                                    : "-"
                                }}
                              </td>
                              <td>
                                <router-link
                                  :to="'/view-succcess-stories/' + data.uuid">
                                  <a
                                    v-show="accessObject?.is_view == 1"
                                    class="fill-btn btn-style cursor-pointer"
                                    >View</a
                                  >&nbsp;
                                </router-link>
                                <a
                                  v-show="accessObject?.is_delete == 1"
                                  class="fill-btn btn-style cursor-pointer"
                                  v-on:click="showDeletePopup(data)"
                                  >Delete</a
                                >&nbsp;
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-show="currentTab == 'REJECTED'">
                <div class="mb-0 radius-15">
                  <div class="card-body p-0 pb-4">
                    <div class="table-responsive">
                      <div class="dataTables_wrapper dt-bootstrap4">
                        <table
                          class="table table-striped table-bordered dataTable"
                          style="width: 100%"
                          role="grid"
                          aria-describedby="example_info">
                          <thead>
                            <tr role="row">
                              <th>Sr. No.</th>
                              <th
                                class="sorting"
                                id="id-custom_request_id"
                                v-on:click="
                                  sorting(
                                    'custom_request_id',
                                    'id-custom_request_id'
                                  )
                                ">
                                <div style="width: 105px">Request ID</div>
                              </th>
                              <th
                                class="sorting"
                                id="id-action_datetime"
                                v-on:click="
                                  sorting(
                                    'action_datetime',
                                    'id-action_datetime'
                                  )
                                ">
                                <div style="width: 145px">Requested Date</div>
                              </th>

                              <th>
                                <div style="width: 250px">
                                  Groom ID First Name Last Name
                                </div>
                              </th>
                              <th>
                                <div style="width: 250px">
                                  Bride ID First Name Last Name
                                </div>
                              </th>
                              <th
                                v-show="
                                  accessObject?.is_delete == 1 ||
                                  accessObject?.is_view == 1
                                ">
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody v-show="!requestedProductLoader">
                            <tr v-for="(data, index) in list" :key="index">
                              <td style="text-align: left">
                                {{
                                  ($refs.listPagination.currentPage - 1) * 10 +
                                  index +
                                  1
                                }}
                              </td>
                              <td style="text-align: left">
                                {{
                                  data.custom_request_id
                                    ? data.custom_request_id
                                    : "-"
                                }}
                              </td>
                              <td style="text-align: left">
                                {{
                                  $helperService.getFormatedDate(
                                    data.action_datetime
                                      ? data.action_datetime
                                      : "-"
                                  )
                                }}
                              </td>
                              <td style="text-align: left">
                                {{
                                  data.groom_registration_no
                                    ? data.groom_registration_no
                                    : "-"
                                }}
                                {{
                                  data.groom_first_name
                                    ? data.groom_first_name
                                    : "-"
                                }}
                                {{
                                  data.groom_last_name
                                    ? data.groom_last_name
                                    : "-"
                                }}
                              </td>
                              <td style="text-align: left">
                                {{
                                  data.bride_registration_no
                                    ? data.bride_registration_no
                                    : "-"
                                }}
                                {{
                                  data.bride_first_name
                                    ? data.bride_first_name
                                    : "-"
                                }}
                                {{
                                  data.bride_last_name
                                    ? data.bride_last_name
                                    : "-"
                                }}
                              </td>

                              <td>
                                <router-link
                                  :to="'/view-succcess-stories/' + data.uuid">
                                  <a
                                    v-show="accessObject?.is_view == 1"
                                    class="fill-btn btn-style cursor-pointer"
                                    >View</a
                                  >&nbsp;
                                </router-link>
                                <a
                                  v-show="accessObject?.is_delete == 1"
                                  class="fill-btn btn-style cursor-pointer"
                                  v-on:click="showDeletePopup(data)"
                                  >Delete</a
                                >&nbsp;
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mx-0 mb-4">
                <div class="col-lg-12 mt-5 text-center">
                  <div class="page-bottom-pagination text-right">
                    <Pagination
                      @page-change="pageChange"
                      @items-per-page-change="itemsPerPageChange"
                      ref="listPagination" />
                  </div>
                </div>
              </div>
              <ErrorComponent @retry="getList(0)" ref="errorComponent" />
            </div>
          </div>
        </div>
        <div
          class="text-center"
          style="margin-top: 20%"
          v-show="accessObject?.is_view == 0 || isShowAccessDeniedMessage">
          <h3>You do not have access to view success story</h3>
        </div>
      </div>
    </div>
    <DeleteModal @remove="accept($event)" ref="acceptModal" />

    <DeleteModal @remove="deleteRecord($event)" ref="rejectModal" />
    <DeleteModal @remove="deleteSuccessStoryRecord($event)" ref="deleteModal" />
  </div>
</template>
<script>
import ErrorComponent from "@/components/ErrorComponent";
import DeleteModal from "@/components/DeleteModal";
import Pagination from "@/components/Pagination";
// import TextModal from "@/components/TextModal";
export default {
  name: "SuccessStories",
  components: {
    ErrorComponent,
    DeleteModal,
    Pagination,
    // TextModal,
  },
  data() {
    return {
      accessObject: this.$helperService.getAccessLevel("Success Stories"),
      uuid: this.$route.params.uuid,
      loader: true,
      isShowAccessDeniedMessage: false,
      type: this.$route.query.type,
      docFile: undefined,
      offset: 0,
      list: [],
      searchObj: {
        keyword: "",
      },
    };
  },
  mounted() {
    // if (!this.accessObject) {
    //   this.isShowAccessDeniedMessage = true;
    //   this.$router.push("/access-denied");
    //   return;
    // }
    this.$helperService.showMenu("true");
    if (this.uuid) {
      this.getDetail();
    }
    if (localStorage.getItem("tab")) {
      var tab = localStorage.getItem("tab");
      this.changeTab(tab);
    } else {
      this.$shareService.deleteMapValue("success_stories_filter")
      this.changeTab("PENDING");
    }
  },
  methods: {
    changeTab(tab) {
      localStorage.setItem("tab", tab);
      this.currentTab = tab;
      this.searchObj.keyword = "";
      this.getFilter();
    },
    getFilter() {
      this.searchObj = this.$shareService.getMapValue("success_stories_filter")
        ? this.$shareService.getMapValue("success_stories_filter")
        : {
            keyword: "",
            type: this.currentTab,
            offset: 0,
          };
      this.$helperService.sortingPrevent(
        this.searchObj.order_by,
        this.searchObj.sort_id
      );
      this.searchObj.type = this.currentTab;
      if (this.searchObj.offset || this.searchObj.offset == 0) {
        this.$refs.listPagination.setTotalCount(this.searchObj.count, 50);
        this.$refs.listPagination.setCurrentPage(this.searchObj.offset + 1);
        this.getList(this.searchObj.offset);
      } else {
        this.getList(0);
      }
    },
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },

    getList(offset, orderBy, sortBy) {
      this.$refs.errorComponent.updateListLoader(true);
      this.list = [];
      this.searchObj.offset = offset;
      this.searchObj.type = this.currentTab;
      if (orderBy) {
        this.searchObj.order_by = orderBy;
      }
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      this.$api
        .getAPI({
          _action: "/success-story/pagination/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.$shareService.setMapValue("success_stories_filter", this.searchObj);
          this.loader = false;
          this.list = res.list;
          this.offset = res.next_offset;
          this.accessObject =
            this.$helperService.getAccessLevel("Success Stories");
          if (offset == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            if (this.currentTab == "ACCEPTED") {
              this.$refs.errorComponent.setData(
                res,
                "No Success Stories Available"
              );
            }
            if (this.currentTab == "REJECTED") {
              this.$refs.errorComponent.setData(
                res,
                " No Rejected Requests Available"
              );
            }
            if (this.currentTab == "PENDING") {
              this.$refs.errorComponent.setData(
                res,
                " No Pending Requests Available"
              );
            }
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
    sorting(sortBy, id) {
      var obj = this.$helperService.sorting(sortBy, id);
      this.getList(0, obj.order_by, obj.sort_by);
    },
    resetFilter() {
      this.searchObj.keyword = "";
      this.getList(0);
    },
    showAcceptPopup(data) {
      this.$refs.acceptModal.showModal(
        "Accept Success Stories",
        "Are you sure you want to accept " + data.custom_request_id,
        data
      );
    },
    showRejectPopup(data) {
      this.$refs.rejectModal.showModal(
        "Reject Success Stories",
        "Are you sure you want to reject " + data.custom_request_id,
        data
      );
    },
    showDeletePopup(data) {
      this.$refs.deleteModal.showModal(
        "Delete Success Stories",
        "Are you sure you want to delete " + data.custom_request_id,
        data
      );
    },

    accept(dataObj) {
      var detail = new Proxy(dataObj, {});
      var obj = {};
      if (detail.uuid) {
        obj.uuid = detail.uuid;
        obj.status = "ACCEPTED";
      }
      this.$api
        .putAPI({
          _action: "/success-story/update-status",
          _body: obj,
        })

        .then((res) => {
          if (res) {
            this.$refs.acceptModal.closeModal();
            this.changeTab("ACCEPTED");
            this.$notify({
              type: "success",
              text: "Success Story accepted successfully",
            });
          }
        })
        .catch(() => {
          this.$refs.deleteModal.removeLoader();
        });
    },

    deleteRecord(dataObj) {
      var detail = new Proxy(dataObj, {});
      var obj = {};
      if (detail.uuid) {
        obj.uuid = detail.uuid;
        obj.status = "REJECTED";
      }
      this.$api
        .putAPI({
          _action: "/success-story/update-status",
          _body: obj,
        })
        .then((res) => {
          if (res) {
            this.changeTab("REJECTED");
            this.$refs.rejectModal.closeModal();
            this.getList(0);
            this.$notify({
              type: "success",
              text: "Success Story rejected successfully",
            });
          }
        })
        .catch(() => {
          this.$refs.rejectModal.removeLoader();
        });
    },
    deleteSuccessStoryRecord(dataObj) {
      var detail = new Proxy(dataObj, {});
      var obj = {};
      if (detail.uuid) {
        obj.uuid = detail.uuid;
        obj.status = "DELETED";
      }
      this.$api
        .putAPI({
          _action: "/success-story/delete/" + detail.uuid,
          _body: obj,
        })
        .then((res) => {
          if (res) {
            this.$refs.deleteModal.closeModal();
            this.getList(0);
            this.$notify({
              type: "success",
              text: "Success Story deleted successfully",
            });
          }
        })
        .catch(() => {
          this.$refs.deleteModal.removeLoader();
        });
    },
    uploadDocument() {
      if (this.docFile) {
        this.$api
          .uploadImageAPI({
            _action: "/import/data",
            _key: "file",
            _file: this.docFile,
            _buttonId: "document-button",
          })
          .then(() => {
            this.$refs.textModal.closeModal();
          });
      } else {
        this.$refs.textModal.closeModal();
      }
    },
  },
};
</script>
